import styled from 'styled-components'
import { Button as SutraButton } from 'sutra/components/Button'

const Button = styled(SutraButton).attrs({ block: true, height: '50px' })`
  border-radius: 5px;

  font-size: 16px;
  line-height: 19px;
`

export { Button }
